import React, { Fragment, useState } from 'react';
import Breadcrumb from '../../../layout/breadcrumb';
import { Input, Card, CardBody, Container, Row, Col, Button, FormGroup, Label, List, Table, Media, CardHeader, Collapse } from 'reactstrap';
import { useWorkSheetsDay } from '../../../hooks/workOrder/useWorkSheetsDay';
import Datetime from 'react-datetime';
import Select from 'react-select';
import { Link } from 'react-router-dom';
import search from '../../../assets/images/search-not-found.png';
import './styleWorkDay.css';
import { pyrsa } from '../../../constant/globalConstantsTypeClients';

//MULTISELECT
import '../../../hooks/componentMultiSelect/MultiSelectDemo.css';
import 'primeicons/primeicons.css';
import 'primereact/resources/themes/lara-light-indigo/theme.css';
import 'primereact/resources/primereact.css';
import { MultiSelect } from 'primereact/multiselect';
import { ToastAletGlobal } from '../../alertDialog/ToastAletGlobal';

export const IndexWorkSheetsDay = () => {

    const { workOrderExams, sections, sectionsDefault, branches, branchesDefault, nim,
        exam_select, date_search, date_search_end,
        handleInputChange, handlePickerValues, handleDate, handleSelectValues, checkTypePrint,
        FilterData, loading, downloadSheetWorkDay, loadingPdf, statusPrint,
        changeCheckbox, changeCheckboxBranch, examsFilter, navigateCaptureResults, setselectedSections, selectedSections, sectiondefault,
        getNimsFromRange, changeFiltersRangeNim, loadingWorkSheets, 

        //? PRINT SELECTOR
        selectedWorkOrders, toggleWorkOrder, toggleSelectAll,allSelected, selectedSet,

        //? TOAST ALERT
        showToast, toastType, toastTitle, toastMessage,
        showToastAlert, closeToastAlert,

        setBranchesDefault

    } = useWorkSheetsDay();
    // console.log("🚀 ~ IndexWorkSheetsDay ~ workOrderExams:", workOrderExams)
    // const txtsection = localStorage.getItem('TextAS');

    if (exam_select !== null) {
    }


    const [filters, setFilters] = useState(true);
    const [filterDate, setFilterDate] = useState(false);
    const [filtersRangeNim, setFiltersRangeNim] = useState(false);
    const urlHelen = localStorage.getItem('url_helen');

    const changeFilters = (typeFilter) => {
        switch (typeFilter) {
            case "date":
                setFilters(!filters);
                setFilterDate(false);
                setFiltersRangeNim(false);
                break;
            case "search":
                setFilters(false);
                setFilterDate(!filterDate);
                setFiltersRangeNim(false);

                break;
            case "range":
                setFilters(false);
                setFilterDate(false);
                setFiltersRangeNim(!filtersRangeNim);

                break;
            default:
                break;
        }
    }


    return (
        <Fragment>
            <div className='container-global-zoom p-2'> 
                <Card
                    className="sticky-header-card-worksheets" 
                    style={{
                    marginBottom: '15px',
                    background: 'linear-gradient(135deg, #002940 0%, #1d5b83 100%)',
                    border: 'none',
                    boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
                }}>
                    <CardBody style={{ padding: '18px 25px' }}>
                        <div className="d-flex align-items-center justify-content-between">
                            <div className="d-flex align-items-center">
                                <div style={{
                                    width: '50px',
                                    height: '50px',
                                    borderRadius: '12px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    marginRight: '15px'
                                }}>
                                    <img alt="flask" className="img-fluid text-info mr-2" src={require("../../../assets/images/laboratory-External/icon-logs.svg")} style={{ width: "60px", height: "60px" }} />
                                </div>
                                <div>
                                    <h4 className="mb-1" style={{ color: '#fff', fontWeight: 700, fontSize: '20px', textAlign: "justify" }}>
                                        Hojas de trabajo
                                    </h4>
                                    <small style={{ color: 'rgba(255, 255, 255, 0.85)', fontSize: '13px' }}>
                                        <i className="fa fa-info-circle mr-1"></i>
                                            Hojas de trabajo clínicas: búsqueda avanzada, vista detallada e impresión de resultados.
                                    </small>
                                </div>
                            </div>

                        </div>
                    </CardBody>
                </Card>
                <Row className='m-b-10'>
                    <Col
                        className="default-according style-1 faq-accordion job-accordion sidebar-filters"
                        xs="12"
                        sm="6"
                        md="12"
                        lg="3"
                        xl="3"
                    >
                        <div className="custom-scroll-container">
                            <Row >
                                <Col sm="12">
                                    <Col sm="12" className='p-l-0 p-r-0' style={{ textAlign: "left" }}>
                                        <Card style={{ boxShadow: '0 4px 12px rgba(0,0,0,0.1)', border: 'none', height: '100%', borderRadius: '12px' }}>
                                            <CardHeader style={{ background: 'linear-gradient(135deg, #0d3b59 0%, #1d5b83 100%)', color: 'white', padding: '15px', borderRadius: '12px 12px 0 0'}}>
                                                <Button color="link" className="p-0 text-white d-flex align-items-center" data-toggle="collapse" onClick={() => changeFilters("date")} data-target="#collapseicon" aria-expanded={filters} aria-controls="collapseicon" style={{ gap: "10px" }} >
                                                    <h6 className="mb-0" style={{ fontWeight: 700, fontSize: '15px' }}>
                                                        Filtros de Búsqueda
                                                    </h6>
                                                </Button>
                                            
                                            </CardHeader>

                                            <Collapse isOpen={filters}>
                                                <div className='p-3'>
                                                    {
                                                        //? RANGE NIM
                                                    }
                                                    
                                                    <Row className="mb-3">
                                                        <Col md="12">
                                                            <Label className='f-w-600 label-report'>
                                                                Rango de NIMs
                                                            </Label>
                                                        </Col>
                                                        
                                                        <Col xs="12" sm="12" md="6" className="mb-2">
                                                            <Input type="number" name="init_range_nim" placeholder="Desde..." className="form-control form-control-sm" onChange={(e) => changeFiltersRangeNim(e.target.value, "init_range_nim")} style={{ borderRadius: "7px" }} />
                                                        </Col>
                                                        <Col xs="12" sm="12" md="6">
                                                            <Input type="number" name="end_range_nim" placeholder="Hasta..." className="form-control form-control-sm" onChange={(e) => changeFiltersRangeNim(e.target.value, "end_range_nim")} style={{ borderRadius: "7px" }} />
                                                        </Col>
                                                    </Row>

                                                    {
                                                        //? ADMISSION DATE
                                                    }
                                                    <Row className="mb-3">

                                                    <Col xs="12" md="6" className="mb-3 mb-md-0">
                                                        <Label className="f-w-600 label-report">
                                                            Fecha de inicio <span style={{ color: "#078fff" }}>*</span>
                                                        </Label>

                                                        <Datetime
                                                            inputProps={{
                                                                placeholder: "Inicio",
                                                                className: "form-control form-control-sm",
                                                                style: { borderRadius: "7px" }
                                                            }}
                                                            timeFormat={false}
                                                            dateFormat="YYYY-MM-DD"
                                                            value={date_search}
                                                            locale="es"
                                                            onChange={(e) => handlePickerValues(e, "date_search")}
                                                        />
                                                    </Col>

                                                    <Col xs="12" md="6">
                                                        <Label className="f-w-600 label-report">
                                                            Fecha fin <span style={{ color: "#078fff" }}>*</span>
                                                        </Label>

                                                        <Datetime
                                                            inputProps={{
                                                                placeholder: "Fin",
                                                                className: "form-control form-control-sm",
                                                                style: { borderRadius: "7px" }
                                                            }}
                                                            timeFormat={false}
                                                            dateFormat="YYYY-MM-DD"
                                                            value={date_search_end}
                                                            locale="es"
                                                            onChange={(e) => handlePickerValues(e, "date_search_end")}
                                                        />
                                                    </Col>

                                                </Row>

                                                    {
                                                        //? SECCTIONS
                                                    }

                                                    <Row className="mb-3">
                                                        <Col sm="12">
                                                            <Label className='f-w-600 label-report'>
                                                                Secciones <span style={{color: "#078fff"}}>*</span>
                                                            </Label>
                                                        
                                                        </Col>
                                                        <Col sm="12" md="12">
                                                            <MultiSelect
                                                                
                                                                className="w-100"
                                                                value={selectedSections}
                                                                options={sectiondefault}
                                                                onChange={(e) => changeCheckbox(e.value)}
                                                                optionLabel="name"
                                                                placeholder="Selecciona secciones..."
                                                                maxSelectedLabels={3}
                                                                selectedItemsLabel="Secciones agregadas"
                                                                filter
                                                                filterPlaceholder="Buscar sección..."
                                                                appendTo="self"
                                                            />
                                                        </Col>

                                                    </Row>
                                                    {
                                                        //? BRANCH
                                                    }
                                                    <Row className="mb-3">
                                                        <Col md="12">
                                                            <Label className='f-w-600 label-report'>
                                                                Sucursales <span style={{color: "#078fff"}}>*</span>
                                                            </Label>
                                                            <Select
                                                                isMulti
                                                                name="branches"
                                                                isClearable
                                                                placeholder="Selecciona una o más sucursales"
                                                                noOptionsMessage={() => "Sin resultados"}
                                                                options={branches}
                                                                value={branchesDefault}
                                                                onChange={(e) => {
                                                                    setBranchesDefault(e);
                                                                    changeCheckboxBranch(e);
                                                                }}
                                                                style={{ borderRadius: "10px" }}
                                                            />
                                                            
                                                        </Col>
                                                    </Row>

                                                    {
                                                        //? IMPRESION TYPE
                                                    }

                                                    <Row className='m-t-5'>
                                                        <Col xs="12" sm="12" md="12" lg="12" xl="12">
                                                            <Label className='f-w-600 label-report'>
                                                                Tipo de impresión <span style={{color: "#078fff"}}>*</span>
                                                            </Label>
                                                        </Col>
                                                    </Row>

                                                    <Row className='m-t-5'>
                                                        <Col xs="9" sm="9" md="9" lg="9" xl="9">
                                                            <Label className="labelCheckPrint">{"Lista"}</Label> <br />
                                                            <Label className="switch">
                                                                <Input type="radio" name="checkTypePrint" value="list" checked={checkTypePrint === "list" ? true : false} onChange={(e) => handleDate(e, "checkTypePrint")} />
                                                                <span className="slider round"></span>
                                                            </Label>
                                                        </Col>
                                                        <Col xs="3" sm="3" md="3" lg="3" xl="3">
                                                            <Label className="labelCheckPrint">{"Detalle"}</Label> <br />
                                                            <Label className="switch">
                                                                <Input type="radio" name="checkTypePrint" value="detail" checked={checkTypePrint === "detail" ? true : false} onChange={(e) => handleDate(e, "checkTypePrint")} />
                                                                <span className="slider round"></span>
                                                            </Label>
                                                        </Col>
                                                    </Row>

                                                    {
                                                        //? ACTIONS
                                                    }

                                                    <b>Acciones</b>
                                                    <br />
                                                        <Row className="mt-3">
                                                            <Col xs="6">
                                                                <Button
                                                                    onClick={FilterData}
                                                                    disabled={loading}
                                                                    color="primary"
                                                                    block
                                                                    style={{
                                                                        borderRadius: '10px',
                                                                        padding: '8px',
                                                                        fontSize: '14px',
                                                                        fontWeight: 600,
                                                                        display: 'flex',
                                                                        justifyContent: 'center',
                                                                        alignItems: 'center',
                                                                        gap: '6px'
                                                                    }}
                                                                    onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-2px)'}
                                                                    onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                                                                >
                                                                    
                                                                    {loading && (
                                                                        <i className="fa fa-spinner fa-spin"></i>
                                                                    )}

                                                                    {loading ? "Filtrando..." : "Filtrar"}
                                                                </Button>
                                                            </Col>

                                                            <Col xs="6">
                                                                <Button
                                                                    color="danger"
                                                                    onClick={downloadSheetWorkDay}
                                                                    disabled={loadingPdf}
                                                                    block
                                                                    style={{
                                                                        borderRadius: '10px',
                                                                        padding: '8px',
                                                                        fontSize: '14px',
                                                                        fontWeight: 600,
                                                                        display: 'flex',
                                                                        justifyContent: 'center',
                                                                        alignItems: 'center',
                                                                        gap: '6px'
                                                                    }}
                                                                    onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-2px)'}
                                                                    onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                                                                    title="Descargar PDF"
                                                                >
                                                                    {loadingPdf && (
                                                                        <i className="fa fa-spinner fa-spin"></i>
                                                                    )}

                                                                    {loadingPdf ? "Generando.." : "Imprimir"}
                                                                </Button>
                                                            </Col>
                                                        </Row>
                                                </div>
                                            </Collapse>
        
                                        </Card>

                                        <Card className='mt-3' style={{ boxShadow: '0 4px 12px rgba(0,0,0,0.1)', border: 'none', height: '100%', borderRadius: '12px' }}>
                                            <CardHeader style={{ background: 'linear-gradient(135deg, #0d3b59 0%, #1d5b83 100%)', color: 'white', padding: '15px', borderRadius: '12px 12px 0 0'}}>
                                                <Button 
                                                    color="link" 
                                                    data-toggle="collapse" 
                                                    className="p-0 text-white d-flex align-items-center"
                                                    onClick={() => changeFilters("search")}
                                                    data-target="#collapseicon"
                                                    aria-expanded={filterDate}
                                                    aria-controls="collapseicon"
                                                    style={{ gap: "10px" }}
                                                >
                                                    <h6 className="mb-0" style={{ fontWeight: 700, fontSize: '15px' }}>
                                                        Busqueda por NIM
                                                    </h6>
                                                </Button>
                                            
                                            </CardHeader>

                                            <Collapse isOpen={filterDate}>
                                                <div className="p-3">
                                                    <Row>
                                                        <Col md="12 m-0">
                                                            <Label className='f-w-600 label-report'>
                                                                Sucursales <span style={{color: "#078fff"}}>*</span>
                                                            </Label>                                                        
                                                            <FormGroup>
                                                                <Select
                                                                    isMulti
                                                                    name="branches"
                                                                    isClearable={true}
                                                                    placeholder="Selecciona una sucursal"
                                                                    noOptionsMessage={() => "Sin resultados"}
                                                                    options={branches}
                                                                    onChange={(e) => changeCheckboxBranch(e)}
                                                                    defaultValue={branchesDefault}
                                                                    menuPortalTarget={document.body}
                                                                    menuPosition="fixed"
                                                                    styles={{
                                                                        menuPortal: (base) => ({
                                                                            ...base,
                                                                            zIndex: 99999999
                                                                        }),
                                                                        menu: (base) => ({
                                                                            ...base,
                                                                            zIndex: 99999999
                                                                        })
                                                                    }}
                                                                />
                                                            </FormGroup>
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <FormGroup className="col-md-12">
                                                            <Label className='f-w-600 label-report'>
                                                                Ingresa el NIM  o Nombre a buscar <span style={{color: "#078fff"}}>*</span>
                                                            </Label>
                                                            <Input className='form-control form-control-sm input-air-primary' name="nim" value={nim} onChange={handleInputChange} />
                                                        </FormGroup>
                                                        <Col md="12">
                                                            <Button
                                                                onClick={FilterData}
                                                                color="primary"
                                                                disabled={loading}
                                                                block
                                                                style={{
                                                                    borderRadius: '10px',
                                                                    padding: '8px',
                                                                    fontSize: '14px',
                                                                    fontWeight: 600,
                                                                    display: 'flex',
                                                                    justifyContent: 'center',
                                                                    alignItems: 'center',
                                                                    gap: '6px'
                                                                }}
                                                                onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-2px)'}
                                                                onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                                                            >
                                                                {loading && (
                                                                    <i className="fa fa-spinner fa-spin"></i>
                                                                )}

                                                                {loading ? "Filtrando..." : "Filtrar"}
                                                            </Button>
                                                            {/* <Button outline color="primary" className={(loading ? "text-center disabled progress-bar-animated progress-bar-striped" : "text-center")} onClick={FilterData}> Filtrar</Button> */}
                                                        </Col> <br />

                                                    </Row>
                                                </div>
                                            </Collapse> 
                                        </Card>


                                    </Col>
                                
                                </Col>
                            </Row>
                        </div>

                    </Col>

                    <Col xs="12"
                        sm="9"
                        md="12"
                        lg="9"
                        xl="9">
                        {loadingWorkSheets ? (
                            <div className="text-center py-5" style={{ marginTop: "80px" }}>
                                <img
                                alt="modal-preview"
                                src={require("../../../assets/images/loginHelenLabs/HelenLabs.png")}
                                className="fa-spin"
                                style={{ width: "15%" }}
                                />
                                <p className="txt-secondary mt-2">Cargando hoja de trabajo...</p>
                            </div>
                            ) : (
                                Object.entries(workOrderExams).length > 0 ?
                                    Object.entries(workOrderExams).map((obj, key) => {
                                        console.log(obj);
                                        const _arrayDoctors = obj[1][0].doctors ? obj[1][0].doctors.split(',').map(name => name.trim()) : [];

                                        return <Row key={obj[0]}>
                                          
                                            <Col xl="12" >
                                                <Card className={`'ribbon-vertical-left-wrapper'`}>
                                                    {obj[1][0].is_micro_sanitary ? (
                                                        <table style={{ width: "100%", borderCollapse: "separate", borderSpacing: "0 4px", fontSize: "12px"}}>
                                                            <thead>
                                                               <tr>
                                                                    <th
                                                                        style={{
                                                                            padding: "15px",
                                                                            textAlign: "left",
                                                                            backgroundColor: "#0f597b",
                                                                            borderRadius: "6px 0 0 0"
                                                                        }}
                                                                    >
                                                                          {key === 0 && (
                                                                            <label className="worksheets-ios-checkbox">
                                                                                    <input
                                                                                        type="checkbox"
                                                                                        checked={allSelected}
                                                                                        onChange={toggleSelectAll}
                                                                                    />
                                                                                    <span className="worksheets-checkmark">
                                                                                        <i className="fa fa-check"></i>
                                                                                    </span>
                                                                                </label>
                                                                          )}
                                                                    </th>                                                                   
                                                          

                                                                    <th
                                                                        colSpan={9}
                                                                        style={{
                                                                            backgroundColor:"#0f597b",
                                                                            borderRadius:"0 6px 0 0"
                                                                        }}
                                                                    />
                                                                </tr>
                                                            </thead>
                                                                <tbody>
                                                                    <tr style={{ backgroundColor: "#f7f7f7ff", borderRadius: "6px 6px 0 0" }}>
                                                                        <td className='cell-color-global'
                                                                            style={{
                                                                                width: "30px",
                                                                                padding: "4px",
                                                                                textAlign: "left",
                                                                                verticalAlign: "top",
                                                                                borderRadius: "6px 0 0 6px"
                                                                            }}
                                                                            rowSpan={2}
                                                                        >
                                                                           <label className="worksheets-ios-checkbox mr-3">
                                                                                <input
                                                                                    type="checkbox"
                                                                                    checked={selectedSet.has(obj[1][0].id_work_order)}
                                                                                    onChange={() => toggleWorkOrder(obj[1][0].id_work_order)}
                                                                                />
                                                                                <span className="worksheets-checkmark">
                                                                                    <i className="fa fa-check"></i>
                                                                                </span>
                                                                            </label>

                                                                            <img
                                                                                src={
                                                                                    obj[1][0].income_type === "Público general"
                                                                                        ? require("../../../assets/images/user/personal.png")
                                                                                        : obj[1][0].income_type === "Empresas"
                                                                                        ? require("../../../assets/images/user/company.png")
                                                                                        : require("../../../assets/images/user/personal.png")
                                                                                }
                                                                                alt="Paciente"
                                                                                style={{
                                                                                    width: 40,
                                                                                    height: 40,
                                                                                    borderRadius: "50%"
                                                                                }}
                                                                            />

                                                                            <div style={{ marginTop: 4 }}>
                                                                                <span
                                                                                    className="f-w-400 f-11 badge badge-light-success"
                                                                                    style={{
                                                                                        cursor: "pointer",
                                                                                        display: "inline-block",
                                                                                        padding: "0.25em 0.5em",
                                                                                        fontSize: "12px"
                                                                                    }}
                                                                                    onClick={() => navigateCaptureResults(obj[0])}
                                                                                >
                                                                                    <strong>{obj[1][0].nim}</strong>
                                                                                </span>
                                                                            </div>
                                                                        </td>

                                                                        <td className="cell-color-global" style={{ padding: "10px" }} colSpan={2}>
                                                                            <strong>Tipo de ingreso:</strong> {obj[1][0].income_type}
                                                                        </td>

                                                                        <td className='cell-color-global' style={{ padding: "10px" }} colSpan={2}>
                                                                            {urlHelen === pyrsa && obj[1][0].income_type === "Empresas" && (
                                                                                <>
                                                                                    <strong>Empresa:</strong> {obj[1][0].name_company ?? "—"}
                                                                                </>
                                                                            )}
                                                                        </td>

                                                                        <td className='cell-color-global' style={{ padding: "10px" }} colSpan={2}>
                                                                            {urlHelen === pyrsa &&
                                                                                obj[1][0].income_type === "Empresas" &&
                                                                                obj[1][0].contract_number_agreement && (
                                                                                    <>
                                                                                        <strong>Convenio:</strong>{" "}
                                                                                        {obj[1][0].contract_number_agreement}
                                                                                    </>
                                                                                )}
                                                                        </td>

                                                                        <td className='cell-color-global' style={{ padding: "10px", textAlign: "right" }}>
                                                                            {obj[1][0].date} / {obj[1][0].name_branch}
                                                                        </td>
                                                                    </tr>

                                                                    <tr
                                                                        style={{
                                                                            backgroundColor: "#f0f0f0ff",
                                                                            borderRadius: "0 0 6px 6px"
                                                                        }}
                                                                    >
                                                                        <td className='cell-color-secondary' style={{ padding: "10px" }} colSpan={7}>
                                                                            <strong>Observaciones:</strong>{" "}
                                                                            {obj[1][0].observations
                                                                                ? obj[1][0].observations
                                                                                : "Sin observaciones"}
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                        </table>
                                                    ) : (
                                                       <table
                                                            style={{
                                                                width: "100%",
                                                                borderCollapse: "separate",
                                                                borderSpacing: "0 4px",
                                                                fontSize: "12px"
                                                            }}
                                                            >
                                                            <thead>
                                                                <tr
                                                                style={{
                                                                    backgroundColor: "#144b6e",
                                                                    color: "#f0f0f0ff",
                                                                    fontSize: "13px"
                                                                }}
                                                                >
                                                                <th
                                                                    style={{
                                                                        width: "30px",
                                                                        padding: "4px",
                                                                        textAlign: "left",
                                                                        borderRadius: "6px 0 0 0"
                                                                    }}
                                                                >
                                                                        {key === 0 && (
                                                                            <label className="worksheets-ios-checkbox">
                                                                                <input
                                                                                    type="checkbox"
                                                                                    checked={allSelected}
                                                                                    onChange={toggleSelectAll}
                                                                                />
                                                                                <span className="worksheets-checkmark">
                                                                                    <i className="fa fa-check"></i>
                                                                                </span>
                                                                            </label>
                                                                        )}
                                                                </th>

                                                                <th style={{ padding: "10px" }}>Nombre</th>
                                                                <th style={{ padding: "10px" }}>Edad</th>
                                                                <th style={{ padding: "10px" }}>Género</th>
                                                                <th style={{ padding: "10px", borderRadius: "0 6px 0 0", textAlign:"right"}}>
                                                                    Fecha / Sucursal
                                                                </th>
                                                                </tr>
                                                            </thead>
                                                            {/*  */}

                                                            <tbody>
                                                                <tr style={{ backgroundColor: "#f0f0f0ff" }}>
                                                                <td className='cell-work-today'
                                                                    style={{
                                                                        width: "30px",
                                                                        padding: "2px",
                                                                        textAlign: "left",
                                                                        verticalAlign: "top",
                                                                        borderRadius: "6px 0 0 6px"
                                                                    }}
                                                                    rowSpan={2}
                                                                >
                                                                   <label
                                                                        className="worksheets-ios-checkbox mr-3"
                                                                        style={{ marginLeft: "2px" }}
                                                                    >
                                                                        <input
                                                                            type="checkbox"
                                                                            checked={selectedSet.has(obj[1][0].id_work_order)}
                                                                            onChange={() => toggleWorkOrder(obj[1][0].id_work_order)}
                                                                        />
                                                                        <span className="worksheets-checkmark">
                                                                            <i className="fa fa-check"></i>
                                                                        </span>
                                                                    </label>
                                                                    <img
                                                                    src={
                                                                        obj[1][0].gender === "Femenino"
                                                                        ? require("../../../assets/images/user/mujer.png")
                                                                        : require("../../../assets/images/user/hombre.png")
                                                                    }
                                                                    alt="Paciente"
                                                                    style={{ width: 40, height: 40, borderRadius: "50%" }}
                                                                    />
                                                                    <div style={{ marginTop: 4 }}>
                                                                    <span
                                                                        className="f-w-400 f-11 badge badge-light-primary"
                                                                        style={{
                                                                        cursor: "pointer",
                                                                        display: "inline-block",
                                                                        padding: "0.25em 0.5em",
                                                                        fontSize: "12px"
                                                                        }}
                                                                        onClick={() => navigateCaptureResults(obj[0])}
                                                                    >
                                                                        <strong>{obj[1][0].nim}</strong>
                                                                    </span>
                                                                    </div>
                                                                </td>

                                                                <td className='cell-color-global' style={{ padding: "4px" }}>
                                                                    <strong>{obj[1][0].name_patient}</strong>
                                                                </td>
                                                                <td className='cell-color-global' style={{ padding: "4px" }}>{obj[1][0].age}</td>
                                                                <td className='cell-color-global' style={{ padding: "4px" }}>{obj[1][0].gender}</td>
                                                                <td className='cell-color-global' style={{ padding: "4px", textAlign: "right" }}>
                                                                    {obj[1][0].date} / {obj[1][0].name_branch}
                                                                </td>
                                                                </tr>

                                                                <tr
                                                                style={{
                                                                    backgroundColor: "#f7f7f7ff",
                                                                    borderRadius: "0 0 6px 6px"
                                                                }}
                                                                >
                                                                <td className='cell-color-secondary' style={{ padding: "4px" }}>
                                                                    <strong>Doctores:</strong>{" "}
                                                                    {_arrayDoctors && _arrayDoctors.length > 0
                                                                    ? _arrayDoctors.join(", ")
                                                                    : "Sin médico"}
                                                                </td>

                                                                <td className='cell-color-secondary' style={{ padding: "4px" }}>
                                                                    <strong>Tipo de ingreso:</strong> {obj[1][0].income_type}
                                                                </td>

                                                                <td className='cell-color-secondary'style={{ padding: "4px" }}>
                                                                    {urlHelen === pyrsa && obj[1][0].income_type === "Empresas" && (
                                                                    <>
                                                                        <strong>Empresa:</strong> {obj[1][0].name_company ?? "—"}
                                                                    </>
                                                                    )}
                                                                </td>

                                                                <td className='cell-color-secondary' style={{ padding: "4px", borderRadius: "0 0 6px 0" }}>
                                                                    {urlHelen === pyrsa &&
                                                                    obj[1][0].income_type === "Empresas" &&
                                                                    obj[1][0].contract_number_agreement && (
                                                                        <>
                                                                        <strong>Convenios:</strong>{" "}
                                                                        {obj[1][0].contract_number_agreement}
                                                                        </>
                                                                    )}
                                                                </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>

                                                    )}

                                                    {checkTypePrint === "list" ? (
                                                        <div style={{ overflowX: "auto", margin: "15px 10px", padding: 5}}>
                                                            {Object.values( obj[1].filter((exam) => exam.is_micro_sanitary).reduce((acc, exam) => {
                                                                const folio = exam.micro_sanitary_info.code;
                                                                if (!acc[folio]) acc[folio] = [];
                                                                    acc[folio].push(exam);
                                                                    return acc;
                                                                }, {})
                                                            ).map((examsGroup, key) => {
                                                                const info = examsGroup[0].micro_sanitary_info;

                                                                return (
                                                                    <div key={key}  style={{ marginBottom: 20, background: "#f9fbfc", borderRadius: 10, padding: "10px 15px", boxShadow: "0 1px 3px rgba(0,0,0,0.1)",}}>
                                                                        <div style={{ display: "flex", justifyContent: "space-between", flexWrap: "wrap", fontSize: 11, marginBottom: 8}}>
                                                                            <div><strong>Folio de muestra:</strong> {info.code}</div>
                                                                            <div><strong>Tipo de muestra:</strong> {info.type_sample}</div>
                                                                            <div><strong>Muestra:</strong> {info.sample_micro}</div>
                                                                        </div>

                                                                        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(0, 1fr))", gap: "6px", marginTop: 8 }} >
                                                                            {examsGroup.map((exam, i) => (
                                                                                <div className='cell-result-today-work ' key={i} style={{ padding: "6px 10px", background: "#e9f4fa", borderRadius: 6, border: "1px solid #d3e7f1", fontSize: 11, display: "flex",alignItems: "center"}}>
                                                                                    <span style={{ flexShrink: 0 }}><strong>{exam.abbreviation_exam}:</strong></span>
                                                                                    <span style={{ flexGrow: 1, borderBottom: "1px solid #aaa", marginLeft: 5, marginTop: "9px" }}></span>
                                                                                </div>
                                                                            ))}
                                                                        </div>
                               

                                                                        {obj[1][0].observations && (
                                                                            <div style={{ fontSize: 11, marginTop: 8, background: "#fff8f6", borderLeft: "3px solid #dc3545", padding: "5px 8px", borderRadius: 5 }} >
                                                                                <i className="icofont icofont-warning-alt f-18 text-danger"></i>
                                                                                &nbsp;<b>Observaciones:</b>
                                                                                <br />
                                                                                <br />
                                                                                <span>{obj[1][0].observations}</span>
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                );
                                                            })}

                                                            {/* --- is_micro_sanitary --- */}
                                                            <div style={{ marginTop: 10, display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))", gap: "8px"}} >
                                                                {obj[1].filter((exam) => !exam.is_micro_sanitary).map((exam, index) => (
                                                                    <div key={"nonmicro-" + index} style={{ padding: "6px 10px", background: "#f7fcff", fontSize: 11, borderRadius: 8, border: "1px solid #d9edf5", display: "flex", alignItems: "center", justifyContent: "space-between", boxShadow: "0 0 2px rgba(0,0,0,0.05)" }}>                                                                    <span style={{ flexShrink: 0 }}>
                                                                        <strong>{exam.abbreviation_exam}:</strong>
                                                                            </span>
                                                                        <span style={{ flexGrow: 1, borderBottom: "1px solid #aaa", marginLeft: 5, marginTop: "9px"}}></span>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                            {obj[1][0].observations && (
                                                                <div
                                                                style={{
                                                                    fontSize: 11,
                                                                    marginTop: 8,
                                                                    background: "#f6fcffff",
                                                                    borderLeft: "3px solid #356fdcff",
                                                                    padding: "6px 10px",
                                                                    borderRadius: 5,
                                                                }}
                                                                >
                                                                <i className="icofont icofont-warning-alt f-18 text-primary"></i>&nbsp;
                                                                <b>Observaciones:</b>&nbsp;<span>{obj[1][0].observations}</span>
                                                                
                                                                </div>
                                                            )}
                                                            
                                                        </div>                          
                                                        ) : (

                                                            <>
                                                            <div
                                                                style={{
                                                                display: "grid",
                                                                gridTemplateColumns: "repeat(auto-fill, minmax(140px, 1fr))",
                                                                gap: "8px",
                                                                marginTop: 8,
                                                                marginLeft:10,
                                                                marginRight:10,
                                                                marginBottom:12
                                                                }}
                                                            >
                                                                {obj[1].map((exam, key2) => {
                                                                const isSingle = exam.list_analytes.length === 1;
                                                                if (isSingle) {
                                                                    const analyte = exam.list_analytes[0];
                                                                    return (
                                                                    <div
                                                                        key={"exam-single-" + key2}
                                                                        style={{
                                                                        padding: "6px 10px",
                                                                        background: "#e9f4fa",
                                                                        borderRadius: 6,
                                                                        border: "1px solid #d3e7f1",
                                                                        fontSize: 11,
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                        }}
                                                                    >
                                                                        <span style={{ flexShrink: 0 }}>
                                                                        <strong>{analyte.code}: </strong>
                                                                        </span>
                                                                        <span
                                                                        style={{
                                                                            flexGrow: 1,
                                                                            borderBottom: "1px solid #aaa",
                                                                            marginLeft: 5,
                                                                            marginTop: "9px",
                                                                        }}
                                                                        ></span>
                                                                    </div>
                                                                    );
                                                                }

                                                                return (
                                                                    <div
                                                                    key={"exam-group-" + key2}
                                                                    style={{
                                                                        marginBottom: 15,
                                                                        background: "#f9fbfc",
                                                                        borderRadius: 10,
                                                                        padding: "10px 15px",
                                                                        boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                                                                        gridColumn: "1 / -1", 
                                                                    }}
                                                                    >
                                                                    <div
                                                                        style={{
                                                                        borderBottom: "1px solid #d3e7f1",
                                                                        paddingBottom: 6,
                                                                        marginBottom: 8,
                                                                        fontSize: 11,
                                                                        color: "#053b5aff",
                                                                        fontWeight: 600,
                                                                        }}
                                                                    >
                                                                        {exam.name_exam}
                                                                    </div>

                                                                    <div
                                                                        style={{
                                                                        display: "grid",
                                                                        gridTemplateColumns: "repeat(auto-fit, minmax(140px, 1fr))",
                                                                        gap: "6px",
                                                                        }}
                                                                    >
                                                                        {exam.list_analytes.map((analyte, i) => (
                                                                        <div
                                                                            key={"analyte-" + i}
                                                                            style={{
                                                                            padding: "6px 10px",
                                                                            background: "#e9f4fa",
                                                                            borderRadius: 6,
                                                                            border: "1px solid #d3e7f1",
                                                                            fontSize: 11,
                                                                            display: "flex",
                                                                            alignItems: "center",
                                                                            }}
                                                                        >
                                                                            <span style={{ flexShrink: 0 }}>
                                                                            <strong>{analyte.code}: </strong>
                                                                            </span>
                                                                            <span
                                                                            style={{
                                                                                flexGrow: 1,
                                                                                borderBottom: "1px solid #aaa",
                                                                                marginLeft: 5,
                                                                                marginTop: "9px",
                                                                            }}
                                                                            ></span>
                                                                        </div>
                                                                        ))}
                                                                    </div>
                                                                    </div>
                                                                );
                                                                })}
                                                            </div>

                                                           {obj[1][0].observations && (
                                                                <div
                                                                style={{
                                                                    fontSize: 11,
                                                                    marginTop: 8,
                                                                    background: "#f6fcffff",
                                                                    borderLeft: "3px solid #356fdcff",
                                                                    padding: "6px 10px",
                                                                    borderRadius: 5,
                                                                }}
                                                                >
                                                                <i className="icofont icofont-warning-alt f-18 text-primary"></i>&nbsp;
                                                                <b>Observaciones:</b>&nbsp;<span>{obj[1][0].observations}</span>
                                                                
                                                                </div>
                                                            )}
                                                            </>

                                                        )}

                                                </Card>
                                            </Col>
                                        </Row>
                                    })
                                    :
                                    <Row>
                                        <Col sm="12">
                                            <Card>
                                                <CardBody>
                                                    <br />
                                                    <div className="search-not-found text-center">

                                                        <div>
                                                            <img src={require("../../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")} style={{ width: "60%" }} alt="" /> <br />
                                                            <label className='f-w-600 f-14 badge badge-light-primary'>No se a registrado ninguna hoja de trabajo</label>
                                                        </div>
                                                    </div>
                                                </CardBody>
                                            </Card>
                                        </Col>
                                    </Row>
                            )}
                    </Col>

                </Row >
            </div >

            {
                //? ALERT GLOBAL
            }

            <ToastAletGlobal
                visible={showToast}
                type={toastType}
                title={toastTitle}
                message={toastMessage}
                onClose={closeToastAlert}
            />
        </Fragment >
    )
}
